import { ReactNode } from "react";
import clsx from "clsx";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function EstateFridgeGoodsWrapper({ children, className }: Props) {
  return (
    <div className="relative grow">
      <div
        className={clsx(
          "absolute inset-0 flex flex-wrap content-start gap-1.5 mr-[0.8125rem] pl-7.5 pr-[0.8125rem] pb-5 overflow-y-auto overflow-x-clip",
          "[--scrollbar-width:0.25rem] [--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
